<template>
  <div id="app">
    <b-button block variant="warning" v-if="updateExists" @click="refreshApp">
      New version available; please refresh
    </b-button>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
        updateExists: false,
      };
    },
    created() {
      document.addEventListener('swUpdated', this.showRefreshUI, {once: true});
    },
    methods: {
      showRefreshUI() {
        this.updateExists = true;
      },
      refreshApp() {
        this.updateExists = false;
        window.location.reload();
      }
    }
  }
</script>
